import { propEq } from 'ramda'

import useCurrentSession from './use-current-session'

const useGoogleEventUserData = () => {
  const session = useCurrentSession()
  const sessionComplete =
    !!session?.id && propEq('registration_complete', '1', session)
  return sessionComplete
    ? {
        userEmail: session.username,
        userFirstName: session.first_name,
        userLastName: session.last_name,
        userPhone: session.phone_number
      }
    : {}
}

export default useGoogleEventUserData
